import { DownloadOutlined } from "@ant-design/icons"
import { Backdrop, CircularProgress } from "@mui/material"
import { Button, Col, Row } from "antd"
import { useState } from "react"
import { ExportManagementReport, ExportTotalLicenseReport } from "../../../API/api"
import AdminLayout from "../../../component/AdminLayout"
import FileSaver from "file-saver";

const Reports = () => {
    const [isLoading,setIsLoading] = useState<boolean>(false)
    
    const downloadManagementReport = () => {
      try {
          setIsLoading(true);
         
          ExportManagementReport()
            .then(async (response: any) => {
              const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
    
              FileSaver.saveAs(blob, "Management-Report.xlsx");
    
              setIsLoading(false);
            })
            .catch((error: any) => {
              console.log("error", error);
              setIsLoading(false);
            });
        } catch (error) {
          console.log("error", error);
          setIsLoading(false);
        }
  }
    const downloadTotalLicenseReport = () => {
        try {
            setIsLoading(true);
           
            ExportTotalLicenseReport()
              .then(async (response: any) => {
                const blob = new Blob([response.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
      
                FileSaver.saveAs(blob, "Total-License-Report.xlsx");
      
                setIsLoading(false);
              })
              .catch((error: any) => {

                console.log("error", error);
                setIsLoading(false);
              });
          } catch (error) {
            console.log("error", error);
            setIsLoading(false);
          }
    }
    return <>
      {" "}
      <AdminLayout>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme: any) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <div>
          <div className="employee-table-header ">
            <Row gutter={16} style={{ alignItems: "center", margin: "12px 16px 0 16px"}}>
              <Col className="gutter-row" lg={12} sm={24}>
                <h3 className="bottom-margin-mob" style={{ float: "left" }}>
                  Reports
                </h3>
              </Col>
              <Col className="gutter-row pm-search-flex" lg={12} sm={24}>
         
              </Col>
            </Row>
          </div>
          <Row>
      <Col lg={12} md={24} xs={24}>

          <div className="report-card">
            <h3 style={{marginTop: "0"}}>Total License Report  </h3>    
            <br />
            <Button onClick={downloadTotalLicenseReport} type="primary" icon={<DownloadOutlined />}>
              Download
            </Button>
          </div>

        </Col>
      <Col lg={12} md={24} xs={24}>

          <div className="report-card">
            <h3 style={{marginTop: "0"}}>Management Report  </h3>
            <br />    
            <Button onClick={downloadManagementReport}  type="primary" icon={<DownloadOutlined />}>
              Download
            </Button>
          </div>

      </Col>
    </Row>
          </div></AdminLayout>
          </>
}
export default Reports
